/**
 * (Observer Pattern) Listen and raise events.
 * @example
 * //Register observer
 * function test(arg){
 *      console.log('salida: ' + arg.p1);
 * }
 * const ob = new Observable_JS();
 * ob.suscribe('category', test);
 * ...
 * //Notify Observers
 * const ob = new Observable_JS();
 * ob.notify('category', {
 *  p1 : "parámetro 1"
 * });
 * // console output:  salida: parámetro 1
 */
class Observable_JS  {
    /**
     * @constructor
     * */
    constructor() {
        /**  List of observers.
        @type {Array} 
        @private
        */
        this.observers = [];
    }
    /**
     * Register Observers.
     * @param {String} pCategory Category or identifier.
     * @param {Function} pFunc callback function.
     */
    subscribe(pCategory, pFunc) {
        this.observers.push({
            Category: pCategory,
            Func: pFunc
        });
    }
    /**
     * Unregister Observers.
     * @param {String} pCategory Category.
     * @param {Function} pFunc callback function.
     */
    unsubscribe(pCategory, pFunc) {
        this.observers = this.observers.filter(obs => !(obs.Category === pCategory && Func === pFunc));
    }
    /**
     * Unregister all Observers from a specific Category.
     * @param {String} pCategory Category.
     */
    unsubscribeAll(pCategory) {
        this.observers = this.observers.filter(obs => obs.Category !== pCategory);
    }
    /**
     * Raise events from a specific Category.
     * @param {String} pCategory Category.
     * @param {Object} pArg Object with argument properties.
     */
    notify(pCategory, pArg) {
        this.observers.forEach(obs => {
            if (obs.Category == pCategory) {
                obs.Func(pArg);
            }
        });
    }
}